import type { TrackedTranslation } from '@ps/web-core-intl';
import type { Alias } from '@ps/web-core-store';

export type SetOnboardingFlowStep = React.Dispatch<React.SetStateAction<Element | null>> | null;

export enum ModalPath {
  ActiveTableLimit = '/poker/active-table-limit',
  ActiveGames = '/poker/active-games',
  PresentationalSizes = '/poker/presentational-sizes'
}

export enum GameView {
  Grid = 'grid',
  List = 'list',
  Simple = 'simple'
}

export interface NavigationTab<T extends string> {
  title: TrackedTranslation;
  shortTitle: TrackedTranslation;
  tabActiveStyle?: string;
  tabName: T;
  animation?: React.FC;
  animationStyle?: string;
  alias?: Alias;
  routeValues?: { [key: string]: string };
  searchParams?: URLSearchParams;
}

export interface NavigationProperties<T extends string> {
  navTabs?: NavigationTab<T>[];
  selectedTab: T;
  onSelectTab: (page: T) => void;
  infoRef?: SetOnboardingFlowStep;
  className?: string;
  preserveQueryParams?: boolean;
}
